import query from './APIServices'

interface CompanyParams {
  id?: number
  name: string
  type: string
  observations?: string
}

export const createNewCompany = async (params: CompanyParams) =>
  await query.post('/cargo/company', params)

export const editNewCompany = async (params: CompanyParams) =>
  await query.patch(`/cargo/company/${params.id}`, {
    name: params.name,
    type: params.type,
    observations: params.observations,
  })

export const deleteCompany = async (idCompany: number) =>
  await query.deleteAPI(`/cargo/company/${idCompany}`)
